import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';

const query = gql`
  mutation logActiveMatchConnectionsDownload ($input: logActiveMatchConnectionsDownloadInput!) {
    logActiveMatchConnectionsDownload(input: $input) {
      clientMutationId
      viewer {
        id
      }
    }
  }
`;

export default graphql(query, {
  name: 'logActiveMatchConnectionsDownload',
});
